import { jobInterestsDefaultValue } from '$constants/formDefaultValues';
import computeYearsOfExperience from '$utils/computeYearsOfExperience';
import sortWorkExperienceFunction from '$utils/sortWorkExperience';
import {
  CandidateBuilder,
  GetSharedCandidatesRosterDataInput,
  GetSharedCandidatesRosterDataOutput,
} from '../candidates.types';

export const getSharedCandidatesRosterData = (builder: CandidateBuilder) =>
  builder.query<
    GetSharedCandidatesRosterDataOutput,
    GetSharedCandidatesRosterDataInput
  >({
    query: ({ sharedRosterId }) => {
      return {
        url: `/candidates/share/${sharedRosterId}`,
        method: 'GET',
      };
    },
    transformResponse: (response: GetSharedCandidatesRosterDataOutput) => {
      response.candidates = response.candidates.map((singleCandidate) => {
        singleCandidate.YearsOfExperience = computeYearsOfExperience(
          singleCandidate.CandidateWorkExperience
        );

        if (!singleCandidate.CandidateJobInterest) {
          singleCandidate.CandidateJobInterest = {
            Id: -1,
            SalaryLowerBound: jobInterestsDefaultValue.Salary[0],
            SalaryUpperBound: jobInterestsDefaultValue.Salary[1],
          };
        }

        // singleCandidate.CandidateSkills = singleCandidate?.CandidateSkills?.map(
        //   ({ Skill, ...rest }: any) => {
        //     return { ...rest, Skill: { ...Skill, title: Skill.Title } };
        //   }
        // );

        if (
          singleCandidate.CandidateWorkExperience &&
          singleCandidate.CandidateWorkExperience.length > 0
        ) {
          singleCandidate.CandidateWorkExperience =
            singleCandidate.CandidateWorkExperience.sort(
              sortWorkExperienceFunction
            );
        }
        return singleCandidate;
      });
      return response;
    },
  });
